import { actions as arcAdsActions } from 'domains/arcAds'

export const fetchArcAds = (payload) => arcAdsActions.fetchArcAds(payload)

export const fetchArcAdDetails = (payload) => arcAdsActions.fetchArcAdDetails(payload)

export const fetchArcAdSources = (payload) => arcAdsActions.fetchArcAdSources(payload)

export const createArcAd = (payload) => arcAdsActions.createArcAd(payload)

export const updateArcAd = (payload) => arcAdsActions.updateArcAd(payload)

export const deleteArcAd = (payload) => arcAdsActions.deleteArcAd(payload)

export const resetFiltersAndSorter = () => arcAdsActions.saveFiltersAndSorter({
  search: '',
  filters: {},
  sorter: {}
})

export const setImagePreview = (payload) => arcAdsActions.setImagePreview(payload)

export const clearImagePreview = (payload) => arcAdsActions.clearImagePreview(payload)